import React from "react";
import S from "../../../styles/components";
import PrimaryControls from "./PrimaryControls";
import ProgressControls from "./ProgressControls";
import VoiceBase from "../../../assets/voicebase.svg";
import Panel from "../../../common/Panel/Panel";
import Switch from "../../../common/Switch";
import connectToMedia from "../../Media/connectToMedia";
import ToolTip from "../../../common/ToolTip";
import VoicebaseReactPlayerContext from "../../../VoicebaseReactPlayerContext";
import { exportTranscriptToText } from "../../../utilities/exportTranscriptToText";
import { ExportIcon, DownloadIcon, LoadingIcon} from "../../../assets/icons";
import _ from "lodash";
import pkgJson from "../../../../package.json";
import { downloadMedia } from "../../../utilities/analytics-parser/utility";

const FLAG_ACTION_MAP = {
  DELETE: "delete",
  REDACT: "redact",
};
const MediaId = {
  Keywords: "Key Words",
  Phrase: "Phrase Spotting",
  Noun: "Verbs/Noun",
  Sentiment: "Sentiment",
  Entities: "Entities",
};

const getSentimentButtonColor = (isSentimentAnalyzerOn) =>
  isSentimentAnalyzerOn ? "#339EEC" : "#9E9E9E";
function preventDefault(e) {
  e.preventDefault();
}

class Index extends React.PureComponent {
  static contextType = VoicebaseReactPlayerContext;

  constructor(props) {
    super(props);
    this.state = {
      isPCIFlagTooltipVisible: false,
      isMoreTooltipVisible: false,
      isKeywordSwitchOn: false,
      isPhraseSwitchOn: false,
      isVerbSwitchOn: false,
      isSentimentAnalyzerSwitchOn: false,
      isCopyId: false,
      MediaIdItem: [
        {
          name: MediaId.Keywords,
          value: true,
        },
        {
          name: MediaId.Phrase,
          value: true,
        },
        {
          name: MediaId.Noun,
          value: true,
        },
        {
          name: MediaId.Sentiment,
          value: true,
        },
        {
          name: MediaId.Entities,
          value: true,
        },
      ],
      mediaDownloadLoading: false,
    };
  }

  onVisibleChangeForPCITooltip = (isPCIFlagTooltipVisible) => {
    this.setState({
      isPCIFlagTooltipVisible,
    });
  };
  onVisibleChangeForMoreTooltip = (isMoreTooltipVisible) => {
    this.setState({
      isMoreTooltipVisible,
    });
    if (!isMoreTooltipVisible) {
      this.setState({
        isCopyId: false,
      });
    }
  };

  flagCall = () => {
    const { handlePCIFlagClick } = this.props;
    this.setState({
      isPCIFlagTooltipVisible: false,
    });
    if (handlePCIFlagClick) {
      handlePCIFlagClick();
    }
  };

  changeSentimentAnalyzer = (event) => {
    const { onChangeSentimentAnalyzer } = this.props;
    onChangeSentimentAnalyzer(event);
    this.setState({ isSentimentAnalyzerSwitchOn: event });
  };
  changeMedia = (event, name, index) => {
    const {
      onChangeSentimentAnalyzer,
      onChangeKeywordAnalyzer,
      onChangePhraseSupportingAnalyzer,
      onChangeVerbNounAnalyzer,
      onChangeEntitiesAnalyzer,
    } = this.props;
    let media = this.state.MediaIdItem;
    media[index].value = event;
    this.setState({ MediaIdItem: [...media] });
    if (name === MediaId.Keywords) {
      onChangeKeywordAnalyzer(event);
    } else if (name === MediaId.Phrase) {
      onChangePhraseSupportingAnalyzer(event);
    } else if (name === MediaId.Noun) {
      onChangeVerbNounAnalyzer(event);
    } else if (name === MediaId.Sentiment) {
      onChangeSentimentAnalyzer(event);
    } else {
      onChangeEntitiesAnalyzer(event);
    }
  };

  setSentimentAnalyzer(speakerSentiments) {
    const { isSentimentAnalyzerSwitchOn } = this.state;
    return (
      <S.TooltipContent>
        <span style={{ opacity: "50%" }}>SENTIMENT ANALYZER</span> <br />
        {speakerSentiments && speakerSentiments.length > 0 ? (
          <S.TooltipContent>
            <Switch
              onChange={this.changeSentimentAnalyzer}
              onClick={this.changeSentimentAnalyzer}
              disabled={false}
              checked={isSentimentAnalyzerSwitchOn}
            />
            <span> {isSentimentAnalyzerSwitchOn ? "on" : "off"}</span>
          </S.TooltipContent>
        ) : (
          <span style={{ opacity: "50%" }}> No sentiment data available! </span>
        )}
      </S.TooltipContent>
    );
  }
  copyIcon() {
    return this.state.isCopyId ? (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.875 6.04541L8.125 14.795L3.75 10.4204"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ) : (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ cursor: "pointer" }}
      >
        <g opacity="0.5">
          <path
            d="M16.8746 14.3746V3.12451H5.62402"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.3745 5.62451H3.12402V16.8745H14.3745V5.62451Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  }
  onClickCopyId = async (event) => {
    const { mediaId } = this.props;
    this.setState({
      isCopyId: true,
    });

    await navigator.clipboard.writeText(mediaId);
  };

  downloadMediaFile = (isHostedApp, mediaDownloadResponse) => {
    const { mediaId, mediaUrl, metaData } = this.props;
    this.setState({ mediaDownloadLoading: true });
    const title = mediaId;
    const contentType = metaData?.contentType;
    downloadMedia(mediaUrl, title, contentType, (resp) => {
      this.setState({ mediaDownloadLoading: false });
      if (!resp.success) {
        if (!isHostedApp && mediaDownloadResponse) {
          mediaDownloadResponse(resp);
          return;
        }
        this.props.showToast(
          "An error occurred while trying to download your file. Please reopen the media and try downloading again.",
          "error"
        );
        return;
      }
      if (!isHostedApp && mediaDownloadResponse) {
        mediaDownloadResponse(resp);
        return;
      }
      this.props.showToast("File downloaded successfully", "success");
    });
  };

  setMoreDetails() {
    const {
      isHostedApp = false,
      exportTranscript = () => {},
      mediaDownloadResponse,
    } = this.context;
    const { metaData, isChatTextMedia } = this.props;
    const { isSentimentAnalyzerSwitchOn } = this.state;
    return (
      <S.TooltipContent style={{ textAlign: "left" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minWidth: "max-content",
          }}
        >
          <>
            <div className="media-top-text" style={{ display: "inline-flex" }}>
              {ExportIcon()}
              <div
                style={{
                  marginLeft: "20px",
                  cursor: "pointer",
                }}
                className="export-transcript"
                onClick={_.debounce(() => {
                  exportTranscriptToText({
                    metaData,
                    exportTranscript,
                    isHostedApp,
                  });
                }, 200)}
              >
                Export Transcript
              </div>
            </div>
            {!isChatTextMedia && (
              <div
                className="media-top-text"
                style={{ display: "inline-flex" }}
              >
                {this.state.mediaDownloadLoading
                  ? LoadingIcon()
                  : DownloadIcon()}
                <div
                  style={{
                    marginLeft: "20px",
                    cursor: "pointer",
                  }}
                  className="export-transcript"
                  onClick={_.debounce(() => {
                    this.downloadMediaFile(isHostedApp, mediaDownloadResponse);
                  }, 200)}
                >
                  {this.state.mediaDownloadLoading
                    ? "Downloading"
                    : "Download Media"}
                </div>
              </div>
            )}
          </>
          {!isHostedApp && (
            <div className="media-top-text" style={{ display: "inline-flex" }}>
              <div
                style={{ marginTop: "5px" }}
                onClick={(event) => this.onClickCopyId(event)}
              >
                {this.copyIcon()}
              </div>
              <div
                style={{
                  marginLeft: "20px",
                  marginTop: "5px",
                  cursor: "pointer",
                }}
              >
                {this.state.isCopyId ? (
                  <div>Copied</div>
                ) : (
                  <div onClick={(event) => this.onClickCopyId(event)}>
                    Copy Media ID
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <hr className="panel-hr-line" />
        {this.state.MediaIdItem.map((media, index) => {
          return (
            <S.MoreDetailTooltipContent>
              <Switch
                onChange={(event) => this.changeMedia(event, media.name, index)}
                onClick={(event) => this.changeMedia(event, media.name, index)}
                disabled={false}
                checked={media.value}
              />
              <span className="media-text"> {media.name}</span>
            </S.MoreDetailTooltipContent>
          );
        })}
        {/* {isHostedApp && ( */}
        <div className="media-top-text">
          <hr className="panel-hr-line" />
          <div>{`v${pkgJson.version}`}</div>
        </div>
        {/* )} */}
      </S.TooltipContent>
    );
  }

  getFlagActionTextForRedact = () => (
    <>
      <span>Please confirm you’d like to mark this</span> <br />
      <span>call as having PCI present.</span> <br /> <br />
      <span>This call will immediately be reprocessed</span> <br />
      <span>to remove all numbers and reviewed</span> <br />
      <span>by your account admin.</span> <br />
      <br />
      <span>NOTE: It might take about 10 minutes</span> <br />
      <span>or more for the system to reflect</span> <br />
      <span>the changes on the media file!</span> <br /> <br />
    </>
  );

  getFlagActionTextForDelete = () => (
    <>
      <span>Please confirm you’d like to mark this</span> <br />
      <span>call as having PCI present.</span> <br /> <br />
      <span>This call will immediately be deleted and</span> <br />
      <span>reviewed by the account admin.</span> <br /> <br />
    </>
  );

  pciFlagCallOverlay(isPCIFlagEnabled, flagAction = FLAG_ACTION_MAP.DELETE) {
    return (
      <S.TooltipContent>
        {flagAction === FLAG_ACTION_MAP.DELETE
          ? this.getFlagActionTextForDelete()
          : this.getFlagActionTextForRedact()}
        <S.FlagCallButtonContent>
          <S.FlagCallButton
            onClick={() => this.flagCall()}
            disabled={isPCIFlagEnabled}
            style={
              isPCIFlagEnabled
                ? { display: "inline-flex", cursor: " not-allowed" }
                : { display: "inline-flex" }
            }
          >
            <S.FlagCallImage>
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.52759 17.8105V4.68555"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.52759 14.061C8.52759 10.311 12.2776 17.811 17.2776 14.061V4.68605C12.2776 8.43605 8.52759 0.936047 3.52759 4.68605"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </S.FlagCallImage>{" "}
            <S.FlagCallText>
              {!isPCIFlagEnabled ? "Flag Call" : "Call already flagged"}
            </S.FlagCallText>
          </S.FlagCallButton>
        </S.FlagCallButtonContent>
      </S.TooltipContent>
    );
  }
  componentDidMount = () => {
    const {
      onChangeSentimentAnalyzer,
      onChangeKeywordAnalyzer,
      onChangePhraseSupportingAnalyzer,
      onChangeVerbNounAnalyzer,
      onChangeEntitiesAnalyzer,
    } = this.props;
    onChangeKeywordAnalyzer(true);
    onChangePhraseSupportingAnalyzer(true);
    onChangeVerbNounAnalyzer(true);
    onChangeSentimentAnalyzer(true);
    onChangeEntitiesAnalyzer(true);
  };
  render() {
    const {
      mediaId,
      speakerSentiments,
      isPCIFlagEnabled,
      showPCIFlag,
      flagAction,
      handlePCIFlagClick,
      isMiniPlayerVisible,
      setClickMinMaxPlayerVisible,
      metaData,
      isChatTextMedia,
    } = this.props;
    const {
      isSentimentAnalyzerSwitchOn,
      isMoreTooltipVisible,
      isPCIFlagTooltipVisible,
    } = this.state;
    const contextData = this.context;
    const { isHostedApp = false } = this.context;
    return (
      <Panel>
        <S.Controls>
          <S.ControlsBar>
            <S.ControlsGroup style={{ flex: "auto" }}>
              <PrimaryControls
                agentDetail={metaData.detail}
                mediaId={mediaId}
              />
            </S.ControlsGroup>
            {showPCIFlag && handlePCIFlagClick && (
              <S.ControlsGroup>
                <ToolTip
                  key="flagCall"
                  placement="bottom"
                  trigger={["click"]}
                  visible={isPCIFlagTooltipVisible}
                  onVisibleChange={this.onVisibleChangeForPCITooltip}
                  overlay={
                    <span>
                      {this.pciFlagCallOverlay(isPCIFlagEnabled, flagAction)}
                    </span>
                  }
                >
                  {isPCIFlagEnabled ? (
                    <S.FlagCallContent
                      onClick={preventDefault}
                      style={{ alignItems: "center" }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.5 13.5V3"
                          stroke="#CD4B32"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M2.5 10.4998C6.5 7.49981 9.5 13.4998 13.5 10.4998V2.99981C9.5 5.99981 6.5 -0.000185549 2.5 2.99981"
                          fill="#CD4B32"
                          stroke="#CD4B32"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <S.ContentTitle>Flag</S.ContentTitle>
                    </S.FlagCallContent>
                  ) : (
                    <S.FlagCallContent
                      onClick={preventDefault}
                      style={{ alignItems: "center" }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.5 13.5V3"
                          stroke="#677791"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M2.5 10.4998C6.5 7.49981 9.5 13.4998 13.5 10.4998V2.99981C9.5 5.99981 6.5 -0.000185549 2.5 2.99981"
                          stroke="#677791"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <S.ContentTitle
                        style={{
                          color: isPCIFlagTooltipVisible
                            ? "#262D38"
                            : "#677791",
                        }}
                      >
                        Flag
                      </S.ContentTitle>
                    </S.FlagCallContent>
                  )}
                </ToolTip>
              </S.ControlsGroup>
            )}
            {!isChatTextMedia && !isHostedApp ? (
              <S.ControlsGroup>
                <S.MinimizeContent
                  onClick={() => setClickMinMaxPlayerVisible()}
                  style={{ alignItems: "center" }}
                >
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.7598 6.875L5.00977 15.625"
                      stroke="#677791"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.00977 8.125V15.625H12.5098"
                      stroke="#677791"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.2598 3.125H3.75977"
                      stroke="#677791"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <S.ContentTitle>Minimize</S.ContentTitle>
                </S.MinimizeContent>
              </S.ControlsGroup>
            ) : (
              <></>
            )}
            <S.ControlsGroup>
              <ToolTip
                style={{ textAlign: "center" }}
                placement="bottom"
                trigger={["click"]}
                onVisibleChange={this.onVisibleChangeForMoreTooltip}
                overlay={<span>{this.setMoreDetails()}</span>}
              >
                <S.SentimentButton>
                  {/* <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke={getSentimentButtonColor(isSentimentAnalyzerSwitchOn)} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13.2485 11.8747C12.9191 12.4446 12.4455 12.9177 11.8753 13.2467C11.3052 13.5756 10.6585 13.7488 10.0003 13.7488C9.34201 13.7488 8.69535 13.5756 8.12519 13.2467C7.55502 12.9178 7.08143 12.4446 6.75195 11.8748" stroke={getSentimentButtonColor(isSentimentAnalyzerSwitchOn)} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.1875 9.375C7.70527 9.375 8.125 8.95527 8.125 8.4375C8.125 7.91973 7.70527 7.5 7.1875 7.5C6.66973 7.5 6.25 7.91973 6.25 8.4375C6.25 8.95527 6.66973 9.375 7.1875 9.375Z" fill={getSentimentButtonColor(isSentimentAnalyzerSwitchOn)} />
                    <path d="M12.8125 9.375C13.3303 9.375 13.75 8.95527 13.75 8.4375C13.75 7.91973 13.3303 7.5 12.8125 7.5C12.2947 7.5 11.875 7.91973 11.875 8.4375C11.875 8.95527 12.2947 9.375 12.8125 9.375Z" fill={getSentimentButtonColor(isSentimentAnalyzerSwitchOn)} />
                  </svg> */}
                  <S.ContentTitle
                    style={{
                      marginLeft: "0",
                      display: "flex",
                      color: isMoreTooltipVisible ? "#262D38" : "#677791",
                    }}
                  >
                    <p className="dot-content">...</p>More
                  </S.ContentTitle>
                </S.SentimentButton>
              </ToolTip>
            </S.ControlsGroup>
            {/* <S.ControlsGroup>
              <img height="24" alt="VoiceBase logo" src={VoiceBase} />
            </S.ControlsGroup> */}
          </S.ControlsBar>
        </S.Controls>
        {/* <div style={{ background: 'rgb(240, 240, 240)', overflow: 'hidden' }}>
          <ProgressControls label={mediaId} />
        </div> */}
      </Panel>
    );
  }
}

export default connectToMedia()(Index);
